import { render, staticRenderFns } from "./TextBoxesBlock.vue?vue&type=template&id=070854c0&"
import script from "./TextBoxesBlock.js?vue&type=script&lang=js&"
export * from "./TextBoxesBlock.js?vue&type=script&lang=js&"
import style0 from "./TextBoxesBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports